module.exports = __webpack_public_path__ + "3edff800bf1ee65c22721391aef5e91b.svg";